import { FREIGHT_TAX } from "../constants.js";
/**
 * Helper function to get freight relation items from the content of an ItemsRelationContent.
 * ProductVariants comes from the ItemsRelationContent in the catalogue API
 *
 * @param productVariants
 */
export const getFreightRelationItems = ({ productVariants, }) => {
    if (!productVariants)
        return [];
    return productVariants.map(({ sku, name, images, priceVariants, product }) => ({
        sku,
        name: name ?? "Frakt",
        tax: FREIGHT_TAX,
        priceVariant: getPriceVariantOrZero(priceVariants, sku),
        image: images?.find(({ url }) => url)?.url ?? undefined,
        shapeIdentifier: product?.shape?.identifier,
    }));
};
function getPriceVariantOrZero(priceVariants, sku) {
    const foundPriceVariant = priceVariants?.find(({ identifier }) => identifier === "default");
    if (!foundPriceVariant)
        throw new Error(`No default price variant for freight item. Sku: ${sku}`);
    return {
        price: foundPriceVariant.price || 0,
        currency: foundPriceVariant.currency || "NOK",
    };
}
